import dayjs from 'dayjs'
import * as _ from 'lodash-es'
import { convertRate, RateInterval } from 'node-irr'

const year = 365

export function calc_APY_between(
  pv: { balance: number; date: number | string },
  fv: { balance: number; date: number | string },
): number | null {
  const days = dayjs(fv.date).diff(pv.date, 'day')
  if (days == 0) return null

  const daily_rate = get_daily_rate({ pv: pv.balance, fv: fv.balance, days })
  return daily_rate_to_APY(daily_rate)
}

export function apr_to_apy(apr: number): number | null {
  const apy = (1 + apr / year) ** year - 1
  return _.round(apy * 100, 2)
}

export function daily_rate_to_APY(daily_rate: number): number | null {
  const apy = convertRate(daily_rate, RateInterval.Year)

  return _.round(apy * 100, 2)
}

function get_daily_rate({
  pv,
  fv,
  days,
}: {
  pv: number
  fv: number
  days: number
}): number {
  // PV*(1+r)^n = FV
  // r = (FV/PV)^(1/n) - 1

  return (fv / pv) ** (1 / days) - 1
}

// APY = (1 + daily_rate)^365 - 1
// daily_rate = (1 + APY)^(1/365) - 1
export function apy_to_daily_rate(apy: number): number {
  return (1 + apy / 100) ** (1 / 365) - 1
}
